/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ButtonIcon from 'DesignSystem/ButtonIcon/index'
import React from 'react'
import TysiaNotifications from 'DesignSystem/Svgs/TysiaNotifications/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Medical/Content/Categories/Category/Questions/Question/Actions/AlertAction/Content",
  isSelected
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let questionAlertValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'alert',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSelected
  
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsOrange400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.400'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mt-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<ButtonIcon
  viewPath={`${viewPath}/ButtonIcon`}
 cursor="pointer"
 paddingBottom={0}
 paddingTop={0}
 paddingLeft={0}
 paddingRight={0}
 onClick={onClick}
 data="question.alert"
 isSelected={questionAlertValueData}
 selectedBackgroundColor="white"
 hoveredBackgroundColor="white"
>
{childProps => (
<TysiaNotifications
{...childProps}
  viewPath={`${viewPath}/TysiaNotifications`}
 width={16}
 height={16}
 stroke={childProps.isSelected ? dtColorsOrange400 : dtColorsNeutral400}
 fill={childProps.isSelected ? dtColorsOrange400 : dtColorsNeutral400}
/>
)}
</ButtonIcon>
</div>
{children}
</React.Fragment>)
}